module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/icon-onslaught.cf0ebd67.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/icon-onslaught.png
// module id = 2840
// module chunks = 11